var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLiveBroadcast = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.814 2.816a.667.667 0 0 1 .943.943 6 6 0 0 0 0 8.485.667.667 0 1 1-.943.943 7.334 7.334 0 0 1 0-10.371m9.428 0c.26-.26.683-.26.943 0a7.334 7.334 0 0 1 0 10.37.667.667 0 0 1-.943-.942 6 6 0 0 0 0-8.485.667.667 0 0 1 0-.943"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.69 4.69a.667.667 0 0 1 .943.943 3.334 3.334 0 0 0 0 4.714.667.667 0 0 1-.943.943 4.667 4.667 0 0 1 0-6.6m5.656 0c.26-.26.683-.26.944 0a4.667 4.667 0 0 1 0 6.6.667.667 0 0 1-.944-.943 3.333 3.333 0 0 0 0-4.714.667.667 0 0 1 0-.943M8 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
}))));
export default SvgLiveBroadcast;